import {
  createCaptureException,
  isSentryEnabled as isEnabled,
} from '@sureapp/wl-toggle-common/dist/services/sentry';

/**
 * The functions exported by `wl-toggle-common` require env vars to function.
 * This file exports helpers used by this app so that they have a simpler
 * interface.
 */

const env = process.env.REACT_APP_ENV!;
const dsn = process.env.REACT_APP_SENTRY_DSN!;

export const isSentryEnabled = () =>
  isEnabled({
    dsn,
    isCypressRunning: !!window.Cypress,
  });

type TCaptureExceptionArguments = Parameters<
  ReturnType<typeof createCaptureException>
>;
export const captureException = (...args: TCaptureExceptionArguments) => {
  if (isSentryEnabled()) {
    return createCaptureException({ env })(...args);
  }

  return isSentryEnabled()
    ? createCaptureException({ env })(...args)
    : Promise.reject();
};
